import { render, staticRenderFns } from "./wf-days-or-date-edit.vue?vue&type=template&id=b2e606e4&scoped=true&"
import script from "./wf-days-or-date-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-days-or-date-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-days-or-date-edit.vue?vue&type=style&index=0&id=b2e606e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e606e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
